export enum LanguageEnum {
	KO = 'KO',
	EN = 'EN',
}

export const LANGUAGES: { label: string; value: LanguageEnum }[] = [
	{
		label: '한국어',
		value: LanguageEnum.KO,
	},
	{
		label: 'English',
		value: LanguageEnum.EN,
	},
];
